import type { IGetHolidaysResponse } from '@vacationtracker/shared/types/holidays'

import type { IOnboardingLocation } from '../../components/onboarding-wizard/types'

export interface IWizardHolidaysImportParams {
  loc: IOnboardingLocation
  locationId: string
  holidays: IGetHolidaysResponse[]
  year: number
  locale: string
}

export const wizardHolidaysImportEvent = ({ loc, locationId, holidays, year, locale }: IWizardHolidaysImportParams) => ({
  eventType: 'LOCATION_HOLIDAYS_IMPORTED',
  eventGroup: 'LOCATION',
  locationId,
  holidays: holidays.map((h) => ({ date: h.valueForApi, name: h.name })),
  year,
  country: loc.countryCode,
  state: loc.subdivisionCode ?? undefined,
  locale,
  recurring: true,
  holidayLib: holidays[0]?.google === true ? 'GOOGLE' : 'DATE_HOLIDAYS',
  // Signup already seeded this location, so the seeded imports go instead of mixing with these.
  ...(loc.isFromSignup ? { replaceImported: true } : {}),
})
